'use client'

import dynamic from 'next/dynamic'
import Image from 'next/image'
import { type ChangeEvent, useRef, useState } from 'react'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'

export default function CodeCertificateForm({
  template,
}: {
  template: string | null
}) {
  const CheckCertificateModal = dynamic<{ code: string; onClose: () => void }>(
    () =>
      import(
        `@/components/${template}/certificado/sobre/check-certificate-modal/check-certificate-modal`
      ).catch(() => {
        return Promise.resolve(() => null)
      }),
    { ssr: false }
  )

  const codeRef = useRef<HTMLInputElement>(null)

  const [code, setCode] = useState('')

  function handleCode(event: ChangeEvent<HTMLFormElement>) {
    event.preventDefault()

    if (codeRef.current?.value) {
      setCode(codeRef.current.value)
    }
  }

  function handleClose() {
    setCode('')
  }

  return (
    <div className="w-full">
      <h4 className="font-medium text-2.5xl text-[neutral-900">
        Consultar Certificado
      </h4>

      <form className="mt-3 flex items-center gap-2" onSubmit={handleCode}>
        <div className="flex h-10 w-full items-center rounded border border-[#D7D7D9] bg-transparent px-4 focus-within:border focus-within:border-primary-800">
          <Image
            alt="Ícone de uma lupa"
            height={16}
            src="/icons/magnifying-glass.svg"
            width={16}
          />
          <Input
            className="h-10 border-transparent bg-transparent px-1 font-semibold text-sm placeholder:text-[#525252] focus:border-transparent"
            placeholder="Validar Certificado"
            ref={codeRef}
          />
        </div>

        <Button
          className="h-10 max-w-23.5 rounded font-semibold text-sm"
          type="submit"
        >
          Pesquisar
        </Button>
      </form>

      <CheckCertificateModal code={code} onClose={handleClose} />
    </div>
  )
}
